import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getCompetences } from '../actions/portfolioActions'
import CompetencesSection from './sections/CompetencesSection'

function CompetencesPage() {
  const dispatch = useDispatch()
  useEffect(() => { dispatch(getCompetences()) }, [dispatch])
  return <CompetencesSection />
}

export default CompetencesPage
